<p-toast></p-toast>
<div *ngIf="accessDenied" class="p-m-3">Access Denied</div>
<div *ngIf="!accessDenied" class="p-m-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="mb-0">{{ clubName }}</h3>
    <button
      class="btn btn-outline-primary btn-sm"
      (click)="loadReservations()"
      [disabled]="loading"
    >
      <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
      {{ loading ? "Refreshing..." : "Refresh" }}
    </button>
  </div>
  <div *ngIf="loading" class="text-center my-5">
    <span class="spinner-border" role="status"></span>
  </div>
  <p-table
    *ngIf="!loading"
    [value]="reservations"
    [paginator]="true"
    [rows]="10"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Court</th>
        <th>Start</th>
        <th>Booker</th>
        <th>Booker's Phone Number</th>
        <th>Status</th>
        <th>VIP Status</th>
        <th>VIP Note</th>
        <th>Fixed Reservation</th>
        <th *ngIf="showMatchInfoColumn">Match Info</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-res>
      <tr [ngClass]="{ 'fixed-row': res.fixed_series_id }">
        <td>{{ res.court?.name || courtMap[res.court_id] || res.court_id }}</td>
        <td>{{ res.reservation_start_time | date : "dd.MM.yyyy. HH:mm" }}</td>
        <td>{{ getUserName(res) }}</td>
        <td>
          <a [href]="'tel:' + getBookerPhone(res)">{{ getBookerPhone(res) }}</a>
        </td>
        <td>
          <span class="status-badge" [ngClass]="getMatchStatusClass(res)">
            {{ getMatchStatusLabel(res) }}
          </span>
        </td>
        <td>
          <p-tag
            [severity]="isVip(res) ? 'success' : 'warning'"
            [value]="isVip(res) ? 'VIP' : 'Not VIP'"
          ></p-tag>
        </td>
        <td>{{ getVipNote(res) }}</td>
        <td>{{ res.fixed_series_id ? "Yes" : "No" }}</td>
        <td *ngIf="showMatchInfoColumn">
          <button
            *ngIf="res.end_match_request_pending"
            pButton
            label="View Match Info"
            class="p-button-text"
            (click)="viewMatchInfo(res)"
          ></button>
        </td>
        <td>
          <ng-container *ngIf="canConfirmArrival(res)">
            <button
              pButton
              label="Confirm Arrival"
              class="p-button-text p-button-success"
              icon="pi pi-check-circle"
              (click)="confirmArrival(res)"
            ></button>
          </ng-container>
          <ng-container
            *ngIf="
              res.started &&
              !res.end_match_request_pending &&
              !res.admin_approve_start
            "
          >
            <button
              pButton
              icon="pi pi-check"
              class="p-button-text"
              (click)="approveReservation(res)"
            ></button>
            <button
              pButton
              icon="pi pi-times"
              class="p-button-text p-button-danger"
              (click)="openDenyDialog(res)"
            ></button>
          </ng-container>
          <ng-container
            *ngIf="
              res.started &&
              res.admin_approve_start &&
              !res.end_match_request_pending
            "
          >
            <button
              pButton
              label="End Match"
              class="p-button-text p-button-warning"
              icon="pi pi-stop-circle"
              (click)="endMatch(res)"
            ></button>
          </ng-container>
          <ng-container *ngIf="res.end_match_request_pending">
            <button
              pButton
              label="End match"
              class="p-button-text"
              (click)="endMatch(res)"
            ></button>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-dialog
  header="Match note"
  [(visible)]="approveDialogVisible"
  [modal]="true"
  [closable]="false"
>
  <div class="p-fluid">
    <div class="p-field">
      <label for="towels">Towels</label>
      <p-dropdown
        id="towels"
        [options]="numberOptions"
        [(ngModel)]="towels"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="balls">Balls</label>
      <p-dropdown
        id="balls"
        [options]="numberOptions"
        [(ngModel)]="balls"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="rackets">Rackets</label>
      <p-dropdown
        id="rackets"
        [options]="numberOptions"
        [(ngModel)]="rackets"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="paymentType">Payment type</label>
      <p-dropdown
        id="paymentType"
        [options]="paymentOptions"
        [(ngModel)]="paymentType"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="noteText">Note</label>
      <input id="noteText" type="text" pInputText [(ngModel)]="noteText" />
    </div>
  </div>
  <p-footer>
    <p-progressSpinner
      *ngIf="actionLoading"
      styleClass="mr-2"
      strokeWidth="4"
      [style]="{ width: '25px', height: '25px' }"
    ></p-progressSpinner>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="approveDialogVisible = false"
      [disabled]="actionLoading"
    ></button>
    <button
      pButton
      label="Submit"
      icon="pi pi-check"
      (click)="submitApprove()"
      [disabled]="actionLoading"
    ></button>
  </p-footer>
</p-dialog>
<p-dialog
  header="Reason"
  [(visible)]="denyDialogVisible"
  [modal]="true"
  [closable]="false"
>
  <textarea
    pInputTextarea
    [(ngModel)]="denyReason"
    rows="5"
    style="width: 100%"
  ></textarea>
  <p-footer>
    <p-progressSpinner
      *ngIf="actionLoading"
      styleClass="mr-2"
      strokeWidth="4"
      [style]="{ width: '25px', height: '25px' }"
    ></p-progressSpinner>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="denyDialogVisible = false"
      [disabled]="actionLoading"
    ></button>
    <button
      pButton
      label="Submit"
      icon="pi pi-check"
      [disabled]="!denyReason || actionLoading"
      (click)="submitDeny()"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  header="End match"
  [(visible)]="endDialogVisible"
  [modal]="true"
  [closable]="false"
>
  <div class="p-fluid">
    <div
      *ngIf="reservationToEnd && !isPhoneBooking(reservationToEnd)"
      class="no-score-toggle"
    >
      <input
        id="noScoreRecorded"
        type="checkbox"
        [(ngModel)]="noScoreRecorded"
      />
      <label for="noScoreRecorded">No score recorded</label>
    </div>
    <div
      *ngIf="
        reservationToEnd &&
        !isPhoneBooking(reservationToEnd) &&
        !noScoreRecorded
      "
      class="scores-section"
    >
      <label class="scores-label">Match Scores</label>
      <div class="scores-grid">
        <div class="score-header">
          <span>Set</span>
          <span>Team 1</span>
          <span>Team 2</span>
        </div>
        <div class="score-row" *ngFor="let set of sets; let i = index">
          <span class="set-label">Set {{ i + 1 }}</span>
          <p-dropdown
            [options]="scoreOptions"
            [(ngModel)]="sets[i][0]"
            [style]="{ width: '70px' }"
          ></p-dropdown>
          <p-dropdown
            [options]="scoreOptions"
            [(ngModel)]="sets[i][1]"
            [style]="{ width: '70px' }"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div
      *ngIf="reservationToEnd && isPhoneBooking(reservationToEnd)"
      class="phone-booking-notice"
    >
      <span class="notice-icon"
        ><lucide-icon name="phone" [size]="16"></lucide-icon
      ></span>
      <span>Phone booking - no scores required</span>
    </div>
    <div
      *ngIf="
        reservationToEnd &&
        !isPhoneBooking(reservationToEnd) &&
        noScoreRecorded
      "
      class="no-score-notice"
    >
      No score will be recorded. No points will be awarded.
    </div>
    <div class="p-field">
      <label for="endTowels">Towels</label>
      <p-dropdown
        id="endTowels"
        [options]="numberOptions"
        [(ngModel)]="towels"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="endBalls">Balls</label>
      <p-dropdown
        id="endBalls"
        [options]="numberOptions"
        [(ngModel)]="balls"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="endRackets">Rackets</label>
      <p-dropdown
        id="endRackets"
        [options]="numberOptions"
        [(ngModel)]="rackets"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="endPaymentType">Payment type</label>
      <p-dropdown
        id="endPaymentType"
        [options]="paymentOptions"
        [(ngModel)]="paymentType"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="endNoteText">Note</label>
      <input id="endNoteText" type="text" pInputText [(ngModel)]="noteText" />
    </div>
  </div>
  <p-footer>
    <p-progressSpinner
      *ngIf="actionLoading"
      styleClass="mr-2"
      strokeWidth="4"
      [style]="{ width: '25px', height: '25px' }"
    ></p-progressSpinner>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="endDialogVisible = false"
      [disabled]="actionLoading"
    ></button>
    <button
      pButton
      label="Submit"
      icon="pi pi-check"
      (click)="submitEnd()"
      [disabled]="actionLoading"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  header="Confirm Player Arrival"
  [(visible)]="confirmArrivalDialogVisible"
  [modal]="true"
  [closable]="false"
>
  <div class="p-fluid">
    <p class="arrival-info">
      Confirm that the player has arrived at the club. This will start the match
      and mark them as present.
    </p>
    <div class="p-field">
      <label for="arrivalTowels">Towels</label>
      <p-dropdown
        id="arrivalTowels"
        [options]="numberOptions"
        [(ngModel)]="towels"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="arrivalBalls">Balls</label>
      <p-dropdown
        id="arrivalBalls"
        [options]="numberOptions"
        [(ngModel)]="balls"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="arrivalRackets">Rackets</label>
      <p-dropdown
        id="arrivalRackets"
        [options]="numberOptions"
        [(ngModel)]="rackets"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="arrivalPaymentType">Payment type</label>
      <p-dropdown
        id="arrivalPaymentType"
        [options]="paymentOptions"
        [(ngModel)]="paymentType"
      ></p-dropdown>
    </div>
    <div class="p-field">
      <label for="arrivalNoteText">Note</label>
      <input
        id="arrivalNoteText"
        type="text"
        pInputText
        [(ngModel)]="noteText"
      />
    </div>
  </div>
  <p-footer>
    <p-progressSpinner
      *ngIf="actionLoading"
      styleClass="mr-2"
      strokeWidth="4"
      [style]="{ width: '25px', height: '25px' }"
    ></p-progressSpinner>
    <button
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="confirmArrivalDialogVisible = false"
      [disabled]="actionLoading"
    ></button>
    <button
      pButton
      label="Confirm Arrival"
      icon="pi pi-check"
      (click)="submitConfirmArrival()"
      [disabled]="actionLoading"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  header="Match Info"
  [(visible)]="matchInfoDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
>
  <div *ngIf="matchInfo">
    <table class="table table-sm">
      <tr>
        <th>Court</th>
        <td>{{ matchInfo.court?.name || courtMap[matchInfo.court_id] }}</td>
      </tr>
      <tr>
        <th>Start</th>
        <td>
          {{ matchInfo.reservation_start_time | date : "dd.MM.yyyy. HH:mm" }}
        </td>
      </tr>
      <tr>
        <th>Players</th>
        <td>
          <ul class="list-unstyled mb-0">
            <li *ngFor="let p of matchInfo.courtReservationPlayer">
              {{ p.player?.full_name || p.player_id }}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <th>Sets</th>
        <td>
          <table class="table table-bordered mb-0">
            <tr>
              <th *ngFor="let i of [1, 2, 3]">Set {{ i }}</th>
            </tr>
            <tr>
              <td *ngFor="let i of [0, 1, 2]">
                {{ matchInfo.sets[i] }} - {{ matchInfo.sets[i + 3] }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</p-dialog>
